module.exports = __webpack_public_path__ + "static/media/puneet.87cefac2.jpg";